// src/components/ui/Input.js
import React from 'react';

const InputField = ({ label, name, value, onChange, placeholder, type = 'text', required = false }) => (
    <div>
        <label className="block text-sm font-medium mb-1 text-gray-300">{label}</label>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            className="w-full p-2 bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors duration-200"
        />
    </div>
);

export default InputField;